import type { Role } from '../gql';

import { randRole, randSentence, randUuid } from '@ngneat/falso';

const mockRole = (overwrite?: Partial<Role>): Role => ({
    description: randSentence(),
    roleName: randRole(),
    roleNumber: randUuid(),
    ...overwrite,
    ['__typename']: 'Role',
});

export { mockRole };
